import request, { appendApiUrl } from '@/utils/request'

// 获取用户消息
export const getUserMessage = (kicoinId, id, pageSize) => {
  let url = appendApiUrl(
    `/user-message/messages?kicoinId=${kicoinId}&pageSize=${pageSize}`
  )
  if (id) {
    url += `&id=${id}`
  }
  return request.get({
    url,
  })
}

// 获取用户未读消息个数
export const getUserMessageCount = (kicoinId) => {
  return request.get({
    url: appendApiUrl(`/user-message/count?kicoinId=${kicoinId}`),
  })
}

// 设置用户消息为已读
export const setUserMessageRead = (kicoinId) => {
  return request.get({
    url: appendApiUrl(`/user-message/read?kicoinId=${kicoinId}`),
  })
}

// 获取未展示的消息tip
export const getUserMessageTip = () => {
  return request.get({
    url: appendApiUrl(`/user-message/notify`),
  })
}
